<main class="validar-comanda-page" [class.scanner-aberto]="cameraAtiva">
  <header class="topo-principal">
    <button type="button" class="botao-icone voltar" (click)="voltar()" aria-label="Voltar para mesas">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 18l-6-6 6-6M9 12h11"/></svg>
    </button>
    <div class="titulo-topo">
      <strong>Validar comanda</strong>
      <span>MeuCardápio.ai</span>
    </div>
  </header>

  <section class="conteudo-principal">
    <div class="introducao">
      <span class="sobretitulo">Check-out rápido</span>
      <h1>A comanda está paga?</h1>
      <p>Escaneie o QR Code ou digite o número para conferir na hora.</p>
    </div>

    <button type="button" class="cta-scanner" (click)="iniciarLeitor()">
      <span class="qr-icone"><i class="fas fa-qrcode" aria-hidden="true"></i></span>
      <span class="cta-texto">
        <strong>Iniciar leitor contínuo</strong>
        <small>Abra a câmera uma vez e valide em sequência</small>
      </span>
      <i class="fas fa-chevron-right seta" aria-hidden="true"></i>
    </button>

    <div class="separador"><span>ou digite o número</span></div>

    <form class="validacao-manual" (ngSubmit)="validarDigitado()">
      <label for="numero-comanda">Número da comanda</label>
      <div class="linha-campo">
        <div class="campo-comanda">
          <i class="far fa-keyboard" aria-hidden="true"></i>
          <input #campoComanda id="numero-comanda" name="numeroComanda" inputmode="numeric"
                 autocomplete="off" placeholder="Ex.: 1028" [(ngModel)]="codigoComanda"
                 [disabled]="validando">
        </div>
        <button type="submit" class="botao-validar" [disabled]="!codigoComanda.trim() || validando">
          <i class="fas" [class.fa-search]="!validando" [class.fa-circle-notch]="validando"
             [class.fa-spin]="validando" aria-hidden="true"></i>
          <span>{{validando ? 'Validando' : 'Validar'}}</span>
        </button>
      </div>
    </form>

    <section #historicoSection class="historico" aria-labelledby="titulo-historico">
      <div class="historico-topo">
        <h2 id="titulo-historico"><i class="fas fa-history" aria-hidden="true"></i> Validações recentes</h2>
        <button *ngIf="historico.length > 3" type="button" (click)="mostrarTodas = !mostrarTodas">
          {{mostrarTodas ? 'Ver menos' : 'Ver todas'}}
        </button>
      </div>

      <div class="historico-vazio" *ngIf="!historico.length">
        <i class="fas fa-qrcode" aria-hidden="true"></i>
        <p>As comandas validadas neste aparelho aparecerão aqui.</p>
      </div>

      <div class="lista-historico" *ngIf="historico.length">
        <article class="item-historico" *ngFor="let item of historicoVisivel" [class.paga]="item.paga">
          <span class="status-icone">
            <i class="fas" [class.fa-check]="item.paga" [class.fa-times]="!item.paga" aria-hidden="true"></i>
          </span>
          <div class="item-dados">
            <strong>Comanda #{{identificacaoComanda(item)}}</strong>
            <span>{{identificacaoMesa(item)}} · {{item.validadaEm | date:'HH:mm'}}</span>
          </div>
          <span class="status-texto">{{item.paga ? 'Paga' : 'Pendente'}}</span>
        </article>
      </div>
    </section>
  </section>

  <nav class="navegacao-inferior" aria-label="Navegação da validação de comandas">
    <button type="button" (click)="irParaInicio()">
      <i class="fas fa-home" aria-hidden="true"></i><span>Início</span>
    </button>
    <button type="button" class="ativo" (click)="focarCampo()">
      <span class="nav-icone-ativo"><i class="fas fa-qrcode" aria-hidden="true"></i></span><span>Validar</span>
    </button>
    <button type="button" (click)="exibirHistorico()">
      <i class="fas fa-history" aria-hidden="true"></i><span>Histórico</span>
    </button>
  </nav>

  <section class="scanner" *ngIf="cameraAtiva" aria-label="Leitor contínuo de QR Code">
    <header class="scanner-topo">
      <button type="button" class="botao-icone" (click)="fecharCamera()" aria-label="Fechar leitor">
        <i class="fas fa-times" aria-hidden="true"></i>
      </button>
      <div>
        <strong>Leitor contínuo</strong>
        <span><i></i> Câmera ativa</span>
      </div>
      <button type="button" class="botao-icone" (click)="alternarSom()" [attr.aria-pressed]="somAtivo"
              [attr.aria-label]="somAtivo ? 'Desativar sons' : 'Ativar sons'">
        <i class="fas" [class.fa-volume-up]="somAtivo" [class.fa-volume-mute]="!somAtivo" aria-hidden="true"></i>
      </button>
    </header>

    <div class="camera-area">
      <zxing-scanner *ngIf="!resultado && !erro" (scanSuccess)="aoLerCodigo($event)"
                     (permissionResponse)="aoResponderPermissaoCamera($event)"
                     (camerasNotFound)="aoFalharCamera()" (scanError)="aoFalharCamera()">
      </zxing-scanner>
      <div class="camera-sombra"></div>
      <div class="scanner-instrucao"><i class="fas fa-qrcode" aria-hidden="true"></i> Aponte para o QR Code da comanda</div>
      <div class="mira" aria-hidden="true">
        <span class="canto superior esquerdo"></span><span class="canto superior direito"></span>
        <span class="canto inferior esquerdo"></span><span class="canto inferior direito"></span>
        <span class="linha-leitura"></span>
      </div>
      <p class="leitura-automatica">A leitura acontece automaticamente</p>

      <div class="scanner-carregando" *ngIf="validando">
        <i class="fas fa-circle-notch fa-spin" aria-hidden="true"></i><span>Conferindo comanda...</span>
      </div>

    </div>
  </section>

  <div class="resultado-fundo" *ngIf="resultado" [class.no-scanner]="!cameraAtiva">
    <section class="resultado-card" [class.pago]="resultado.paga" [class.pendente]="!resultado.paga"
             aria-live="assertive">
      <div class="resultado-conteudo">
        <span class="resultado-icone"><i class="fas" [class.fa-check]="resultado.paga"
                                        [class.fa-times]="!resultado.paga" aria-hidden="true"></i></span>
        <div>
          <span class="resultado-rotulo">{{resultado.paga ? 'Pagamento confirmado' : 'Pagamento pendente'}}</span>
          <strong>Comanda #{{identificacaoComanda(resultado)}}</strong>
          <small>{{identificacaoMesa(resultado)}} · {{resultado.valor | currency:'BRL'}}</small>
        </div>
      </div>
      <button type="button" (click)="cameraAtiva ? continuarLendo() : novaValidacao()">
        {{cameraAtiva ? 'Continuar lendo' : 'Nova validação'}}
      </button>
    </section>
  </div>

  <div class="resultado-fundo erro-fundo" *ngIf="erro && !resultado">
    <section class="resultado-card erro-card" [ngClass]="'erro-' + categoriaErro"
             role="alertdialog" aria-live="assertive" aria-modal="true">
      <div class="resultado-conteudo">
        <span class="resultado-icone"><i class="fas" [ngClass]="iconeErro" aria-hidden="true"></i></span>
        <div>
          <span class="resultado-rotulo">{{rotuloErro}}</span>
          <strong>{{tituloErro}}</strong>
          <small>{{erro}}</small>
        </div>
      </div>
      <button type="button" (click)="fecharErro()">
        {{cameraAtiva ? 'Continuar lendo' : 'Nova validação'}}
      </button>
    </section>
  </div>
</main>
